import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from './AdminLayout';
import Navbar from './Navbar';
import { isAdminPath, isAdminRole } from './navigation';

/**
 * Picks the page frame: the sidebar layout for a signed-in admin on an admin
 * screen, the top Navbar everywhere else (public pages, the mechanic
 * schedule, an admin browsing the public site).
 */
const AppChrome: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { pathname } = useLocation();

  if (isAdminPath(pathname)) {
    // RouteGuard shows its own loader while the session is restored; rendering
    // the top bar meanwhile would flash it before the sidebar replaces it.
    if (loading) return <>{children}</>;
    if (isAuthenticated && isAdminRole(user?.role)) {
      return <AdminLayout>{children}</AdminLayout>;
    }
  }

  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

export default AppChrome;
